<template lang="pug">
b-modal#ticketVoucherDetail(
  ref="ticketVoucherDetail"
  :title='$t("ui.ticket_voucher_detail")'
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  :busy="loading"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th(width="35%")
              span  DEPOSIT
            th(width="65%")
              span &nbsp;
        tbody.clusterize-content
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.member") }}
            td
              span {{ ticketDetail.member_id }}
          tr
            td
              span {{ $t("ui.domain") }}
            td
              span {{ ticketDetail.domain_name }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
              span.font-weight-bold.text-danger(v-if="ticketDetail.exchanged_amount") {{ (ticketDetail.deposit_method == 'USDT'? "(" + $n(ticketDetail.exchanged_amount, 'currency') + ")" : "" )}}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.target_bank_id }}
          //- tr
          //-   td
          //-     span {{ $t("ui.bank_owner") }}
          //-   td
          //-     span {{ ticketDetail.target_bank_owner }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.target_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.target_bank_acc_holder }}
          tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
            td
              span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
            td
              span {{ ticketDetail.target_bank_acc_remark }}
          tr(v-if="['AUD'].includes(getCurrencyCode)")
            td
              span {{ $t("ui.payid") }}
            td
              span {{ ticketDetail.target_bank_acc_remark_2 }}
          //- tr
          //-   td
          //-     span {{ $t("ui.ref_no") }}
          //-   td
          //-     span {{ ticketDetail.ref_no }}
          tr
            td
              span {{ $t("ui.deposit_date") }}
            td
              span(v-if="ticketDetail.deposit_date") {{ $moment(ticketDetail.deposit_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.deposit_method") }}
            td
              span {{ ticketDetail.deposit_method }}
          tr
            td
              span {{ $t("ui.promo") }}
            td
              span {{ ticketDetail.promotion_id }}
          tr(v-if="ticketDetail.deposit_method == 'USDT'")
            td
              span {{ $t("ui.exchanged_currency") }}
            td
              span {{ ticketDetail.exchanged_currency }}
          tr(v-if="ticketDetail.deposit_method == 'USDT'")
            td
              span {{ $t("ui.rate") }}
            td
              //- span {{ ticketDetail.rate }}
              span {{ ticketDetail.base_rate }}
          tr(v-if="ticketDetail.deposit_method == 'USDT'")
            td
              span {{ $t("ui.rate_php") }}
            td
              //- span {{ ticketDetail.rate_php }}
              span {{ ticketDetail.exchange_rate }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}       
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td(v-if="ticketDetail.modified_date")
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td(v-if="ticketDetail.created_date")
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    div(slot="modal-footer")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      feedback: {
        success: true,
        status: ""
      },
      remark: ""
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.getTicketVoucherDetail();
    },
    getTicketVoucherDetail: function() {
      let url = config.ticketVoucherDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = (response.data.dt.length > 0) ? response.data.dt[0] : null;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.ticketVoucherDetail.hide();
    },
  }
};
</script>
